(function () {
  // Mobile navigation
  var menu = document.querySelector('.menu');
  var nav = document.querySelector('.links');
  if (menu && nav) {
    menu.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      menu.setAttribute('aria-expanded', open);
      menu.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('open');
        menu.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Flavor details dialog (home page lineup)
  document.querySelectorAll('[data-flavor-section]').forEach(function (section) {
    var dataEl = section.querySelector('script[type="application/json"]');
    var dialog = section.querySelector('dialog');
    if (!dataEl || !dialog) return;
    var flavors = JSON.parse(dataEl.textContent);
    var active = 0;

    function show(i) {
      active = (i + flavors.length) % flavors.length;
      var f = flavors[active];
      dialog.querySelector('[data-title]').textContent = f.name;
      dialog.querySelector('[data-description]').textContent = f.description;
      dialog.querySelector('[data-ingredients]').textContent = f.ingredients;
      dialog.querySelector('[data-weight]').textContent = f.weight;
      var img = dialog.querySelector('[data-image]');
      img.src = f.image;
      img.alt = 'Doc’s Savory ' + f.name + ' front and back label';
      var buy = dialog.querySelector('[data-buy]');
      dialog.querySelector('[data-soon]').hidden = !f.coming_soon;
      if (f.variant_id && !f.coming_soon) {
        buy.hidden = false;
        buy.querySelector('[name="id"]').value = f.variant_id;
        buy.querySelector('[data-price]').textContent = f.price;
        var btn = buy.querySelector('button[type="submit"]');
        btn.disabled = !f.available;
        btn.textContent = f.available ? 'Add to cart' : 'Sold out';
        buy.querySelector('[data-url]').href = f.url;
      } else {
        buy.hidden = true;
      }
      dialog.querySelector('[data-note]').hidden = !!f.variant_id || f.coming_soon;
      if (!dialog.open) dialog.showModal();
    }

    section.querySelectorAll('[data-flavor-index]').forEach(function (b) {
      b.addEventListener('click', function () { show(parseInt(b.dataset.flavorIndex, 10)); });
    });
    dialog.querySelector('.close').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) {
      if (e.target !== dialog) return;
      var r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
    });
    dialog.querySelector('[data-prev]').addEventListener('click', function () { show(active - 1); });
    dialog.querySelector('[data-next]').addEventListener('click', function () { show(active + 1); });
  });

  // Product page quantity stepper
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelector('[data-qty-minus]').addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    q.querySelector('[data-qty-plus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 0) + 1; });
  });

  // Product page gallery thumbnails
  var mainImg = document.querySelector('[data-main-media]');
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      mainImg.src = t.dataset.thumb;
      mainImg.removeAttribute('srcset');
      document.querySelectorAll('[data-thumb]').forEach(function (o) { o.setAttribute('aria-current', o === t); });
    });
  });
})();
